import { useCallback, useSyncExternalStore } from "react";

/** Reactive browser connectivity hint. Server recovery still requires a request. */
export function useOnlineStatus(): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    if (typeof window === "undefined") return () => {};
    window.addEventListener("online", onChange);
    window.addEventListener("offline", onChange);
    return () => {
      window.removeEventListener("online", onChange);
      window.removeEventListener("offline", onChange);
    };
  }, []);

  const getSnapshot = () => (typeof navigator === "undefined" ? true : navigator.onLine);
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
